import React, { useState, useEffect } from "react";
import "../Styles/Navbar.css";
import "../Styles/EuropeVisa.css";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import {
  FaChevronDown,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp
} from "react-icons/fa";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // The burger menu is used up to 1024px (see TabletRefine.css).
    if (window.innerWidth > 1024) return;
    const api = window.Tawk_API;
    if (!api) return;
    if (isOpen) {
      api.hideWidget?.();
    } else {
      api.showWidget?.();
    }
  }, [isOpen]);
  const [showVisa, setShowVisa] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showAbout, setShowAbout] = useState(false);

  function Page() {
    window.scrollTo(0, 0);
  }

  function handleMobileLinkClick() {
    window.scrollTo(0, 0);
    setIsOpen(false);
    setShowVisa(false);
    setShowResources(false);
    setShowAbout(false);
  }

  function CloseToggle() {
    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler && navbarToggler.offsetParent !== null) {
      navbarToggler.click();
    }
  }

  return (
    <div className="navbar-wrapper">
      {/* Custom Mobile Burger Button - Shows only on mobile (max-width: 991px). Placed as sibling to stack above overlay */}
      <button
        className={`mobile-menu-burger d-lg-none border-0 bg-transparent ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isOpen}
        type="button"
      >
        <span className="burger-line burger-line-1"></span>
        <span className="burger-line burger-line-2"></span>
        <span className="burger-line burger-line-3"></span>
      </button>

      <nav className="navbar navbar-expand-lg navbar-custom py-lg-3 py-md-2 py-2">
        {/* Brand Logo */}
        <Link
          className="navbar-brand ms-lg-4 mx-auto mx-lg-4 d-flex align-items-center"
          to="/"
          onClick={handleMobileLinkClick}
        >
          <img
            className="logo"
            src={process.env.PUBLIC_URL + "/Logo.webp"}
            alt="Vidya Education Abroad"
            height="70"
          />
        </Link>

        {/* Desktop Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav gap-1 gap-md-2 gap-lg-3 mb-2 mb-lg-0 mx-auto">
            <li className="nav-item linkss">
              <Link
                onClick={() => {
                  Page();
                  CloseToggle();
                }}
                className="nav-link text-nowrap fs-5 nav-link-custom"
                to="/migrate"
              >
                Migrate
              </Link>
            </li>
            <li className="nav-item linkss">
              <Link
                onClick={() => {
                  Page();
                  CloseToggle();
                }}
                className="nav-link text-nowrap fs-5 nav-link-custom"
                to="/work"
              >
                Work
              </Link>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss">
              <Link
                onClick={() => {
                  Page();
                  CloseToggle();
                }}
                className="nav-link nav-link-custom"
                to="/study"
              >
                Study
              </Link>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss nav-dropdown">
              <Link
                onClick={() => { Page(); CloseToggle(); }}
                className="nav-link nav-link-custom"
                to="/visa"
              >
                Visa <span className="nav-dropdown-arrow">▾</span>
              </Link>
              <div className="nav-dropdown-menu">
                <Link to="/visa" onClick={() => { Page(); CloseToggle(); }}>All Visa Services</Link>
                <Link to="/europe-visa" onClick={() => { Page(); CloseToggle(); }}>Europe Visa</Link>
                <Link to="/study-visa" onClick={() => { Page(); CloseToggle(); }}>Study Visa</Link>
                <Link to="/latvia-trp" onClick={() => { Page(); CloseToggle(); }}>Latvia TRP</Link>
                <Link to="/canada-pr" onClick={() => { Page(); CloseToggle(); }}>Canada PR</Link>
              </div>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss">
              <Link
                onClick={() => {
                  Page();
                  CloseToggle();
                }}
                className="nav-link nav-link-custom"
                to="/coaching"
              >
                Coaching
              </Link>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss nav-dropdown">
              <Link
                onClick={() => { Page(); CloseToggle(); }}
                className="nav-link nav-link-custom"
                to="/about"
              >
                About Us <span className="nav-dropdown-arrow">▾</span>
              </Link>
              <div className="nav-dropdown-menu">
                <Link to="/about" onClick={() => { Page(); CloseToggle(); }}>About Us</Link>
                <Link to="/office" onClick={() => { Page(); CloseToggle(); }}>Our Office</Link>
                <Link to="/LibaMigration" onClick={() => { Page(); CloseToggle(); }}>Liba Migration</Link>
              </div>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss nav-dropdown">
              <Link
                onClick={() => { Page(); CloseToggle(); }}
                className="nav-link nav-link-custom"
                to="/newsletters"
              >
                Resources <span className="nav-dropdown-arrow">▾</span>
              </Link>
              <div className="nav-dropdown-menu">
                <Link to="/blog" onClick={() => { Page(); CloseToggle(); }}>Blogs</Link>
                <Link to="/newsletters" onClick={() => { Page(); CloseToggle(); }}>Newsletters</Link>
                <Link to="/vea-promises" onClick={() => { Page(); CloseToggle(); }}>VEA Promises</Link>
              </div>
            </li>
            <li className="nav-item text-nowrap fs-5 linkss">
              <Link
                onClick={() => {
                  Page();
                  CloseToggle();
                }}
                className="nav-link nav-link-custom"
                to="/faq"
              >
                FAQ
              </Link>
            </li>
          </ul>
          <Link
            to="/visit"
            onClick={() => {
              Page();
              CloseToggle();
            }}
            className="lmbtn text-nowrap mx-2 ms-md-3 mx-lg-3 fs-6 fs-md-5 d-md-inline-flex d-none text-white text-decoration-none align-items-center justify-content-center text-center"
          >
            Read more
          </Link>
        </div>
      </nav>

      {/* Dynamic Custom Mobile Drawer Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="mobile-nav-drawer d-lg-none"
          >
            {/* Ambient Background Glowing Blobs */}
            <div className="mobile-nav-blob mobile-nav-blob-1" />
            <div className="mobile-nav-blob mobile-nav-blob-2" />
            <div className="mobile-nav-grid" />

            <div className="mobile-nav-inner container px-4 py-5 d-flex flex-column justify-content-between h-100">
              {/* Scrollable menu links */}
              <div className="mobile-nav-links-scroll mt-5">
                <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.05 }}
                  >
                    <Link to="/migrate" className="mobile-nav-link" onClick={handleMobileLinkClick}>
                      Migrate
                    </Link>
                  </motion.li>

                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 }}
                  >
                    <Link to="/work" className="mobile-nav-link" onClick={handleMobileLinkClick}>
                      Work
                    </Link>
                  </motion.li>

                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.15 }}
                  >
                    <Link to="/study" className="mobile-nav-link" onClick={handleMobileLinkClick}>
                      Study
                    </Link>
                  </motion.li>

                  {/* Accordion: Visa Services */}
                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2 }}
                    className="mobile-nav-dropdown-item"
                  >
                    <button
                      className="mobile-nav-link dropdown-toggle-btn d-flex align-items-center justify-content-between w-100 text-start border-0 bg-transparent p-0"
                      onClick={() => setShowVisa(!showVisa)}
                      type="button"
                    >
                      <span>Visa Services</span>
                      <FaChevronDown className={`chevron-icon ${showVisa ? "rotated" : ""}`} />
                    </button>
                    <AnimatePresence initial={false}>
                      {showVisa && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="mobile-submenu overflow-hidden mt-2 ps-3 d-flex flex-column gap-2"
                        >
                          <Link to="/visa" className="mobile-submenu-link" onClick={handleMobileLinkClick}>All Visa Services</Link>
                          <Link to="/europe-visa" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Europe Visa</Link>
                          <Link to="/study-visa" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Study Visa</Link>
                          <Link to="/latvia-trp" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Latvia TRP</Link>
                          <Link to="/canada-pr" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Canada PR</Link>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.li>

                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.25 }}
                  >
                    <Link to="/coaching" className="mobile-nav-link" onClick={handleMobileLinkClick}>
                      Coaching
                    </Link>
                  </motion.li>

                  {/* Accordion: Resources */}
                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 }}
                    className="mobile-nav-dropdown-item"
                  >
                    <button
                      className="mobile-nav-link dropdown-toggle-btn d-flex align-items-center justify-content-between w-100 text-start border-0 bg-transparent p-0"
                      onClick={() => setShowResources(!showResources)}
                      type="button"
                    >
                      <span>Resources</span>
                      <FaChevronDown className={`chevron-icon ${showResources ? "rotated" : ""}`} />
                    </button>
                    <AnimatePresence initial={false}>
                      {showResources && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="mobile-submenu overflow-hidden mt-2 ps-3 d-flex flex-column gap-2"
                        >
                          <Link to="/blog" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Blogs</Link>
                          <Link to="/newsletters" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Newsletters</Link>
                          <Link to="/vea-promises" className="mobile-submenu-link" onClick={handleMobileLinkClick}>VEA Promises</Link>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.li>

                  {/* Accordion: About Us */}
                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.35 }}
                    className="mobile-nav-dropdown-item"
                  >
                    <button
                      className="mobile-nav-link dropdown-toggle-btn d-flex align-items-center justify-content-between w-100 text-start border-0 bg-transparent p-0"
                      onClick={() => setShowAbout(!showAbout)}
                      type="button"
                    >
                      <span>About Us</span>
                      <FaChevronDown className={`chevron-icon ${showAbout ? "rotated" : ""}`} />
                    </button>
                    <AnimatePresence initial={false}>
                      {showAbout && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="mobile-submenu overflow-hidden mt-2 ps-3 d-flex flex-column gap-2"
                        >
                          <Link to="/about" className="mobile-submenu-link" onClick={handleMobileLinkClick}>About Us</Link>
                          <Link to="/office" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Our Office</Link>
                          <Link to="/LibaMigration" className="mobile-submenu-link" onClick={handleMobileLinkClick}>Liba Migration</Link>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.li>

                  <motion.li
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                  >
                    <Link to="/faq" className="mobile-nav-link" onClick={handleMobileLinkClick}>
                      FAQ
                    </Link>
                  </motion.li>
                </ul>
              </div>

              {/* Drawer Bottom CTA and Social Icons */}
              <div className="mobile-nav-footer mt-auto pt-4">
                <motion.div
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.45 }}
                  className="mb-4"
                >
                  <Link
                    to="/consultationForm"
                    className="mobile-nav-cta btn py-3 w-100 fw-bold rounded-4 text-center text-white"
                    onClick={handleMobileLinkClick}
                  >
                    Book Free Consultation 🍁
                  </Link>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="d-flex justify-content-center gap-4 mobile-nav-socials fs-3"
                >
                  <a href="https://www.facebook.com/libamigration" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Facebook">
                    <FaFacebook />
                  </a>
                  <a href="https://www.instagram.com/liba_migration" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="LinkedIn">
                    <FaLinkedin />
                  </a>
                  <a href="https://wa.me/message" target="_blank" rel="noopener noreferrer" className="social-icon-link" aria-label="WhatsApp">
                    <FaWhatsapp />
                  </a>
                </motion.div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}